import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError, retry } from 'rxjs/operators';
import { Branch, Consignment, VehicleTypes, CustomerLookup, StandingOrderModel } from '../../models';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CreateBranchRequest, PaginationBranchRequest } from '../branch';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse, PaginationRequest } from '../config/common';
import { requestQuery } from '../../../@shared/untils';
import {
  PaginationCustomerRequest, CreateCustomerRequest,
  XeroCustomer, ConsignmentOverviewRequest, ConsignmentOverviewDto,
  CustomerUsageSummaryDto, CustomerStatusRequest, CustomerStatusDto, ExportCustomerDataRequest
} from './customer.DTO';
import { Customer, StandardOperatingProcedure } from 'src/@core/models/customer';
import { of as observableOf } from 'rxjs';
import { BulkDelete } from 'src/@core/models/bulk-delete';
import { MediaObject } from 'src/@core/models/mediaobject';
import { ResponseType } from '@angular/http';

@Injectable()
export class CustomerService {

  constructor(
    private _http: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService
  ) { }
  public getCustomers(request: PaginationCustomerRequest, disableSpinner?: boolean): Observable<PaginationResponse<Customer>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Customer>>(`${API.CUSTOMER.GET_CUSTOMER}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public getCustomersNew(request: PaginationCustomerRequest, disableSpinner?: boolean): Observable<PaginationResponse<Customer>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Customer>>(`${API.CUSTOMER.GET_CUSTOMER_NEW}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getAllCustomer(): Observable<PaginationResponse<Customer>> {
    this._spinner.show(true);
    const request = new PaginationCustomerRequest();
    return this._http.get<PaginationResponse<Customer>>(`${API.CUSTOMER.GET_CUSTOMER}?${requestQuery(request)}`).pipe(tap(() => this._spinner.hide()));
  }

  public create(model: CreateCustomerRequest) {
    this._spinner.show();
    return this._http.post(`${API.CUSTOMER.CREATE}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_CUSTOMER);
          this._spinner.hide();
        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error.errors[0]);
          }
          throw err;
        })
      );
  }
  public update(model: CreateCustomerRequest, id: string) {
    return this._http.put<Customer>(API.CUSTOMER.UPDATE(id), model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.UPDATE_CUSTOMER);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }
  public delete(id: string) {
    return this._http.delete(API.CUSTOMER.DELETE(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_CUSTOMER);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  public getOneCustomer(id: string): Observable<any> {
    return this._http.get<Customer>(`${API.CUSTOMER.GET_ONE(id)}`);

  }
  public getCustomerEntities(id: string): Observable<any> {
    return this._http.get<Customer>(`${API.CUSTOMER.GET_CUSTOMER_ENTITIES(id)}`);

  }


  public getCustomerVehicleTypes(customerId: string): Observable<any> {
    return this._http.get<VehicleTypes>(`${API.CUSTOMER.GET_CUSTOMER_VEHICLETYPES(customerId)}`);

  }

  public addSupplierCustomer(step: number, id: string, arrSupplier: any[]) {
    let object = {
      "step": step,
      "customerID": id,
      "supplierID": arrSupplier
    }
    return this._http.post(`${API.CUSTOMER.ADD_SUPPLIER_CUSTOMER}`, object)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.ADD_SUPPLIER_CUSTOMER);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  public addCustomerVehicleType(customerId: string, arrVehicleType: any[]) {
    let object = {
      "customerID": customerId,
      "VehicleTypeID": arrVehicleType
    }
    return this._http.post(`${API.CUSTOMER.ADD_VEHICLETYPE_CUSTOMER}`, object)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.ADD_VEHICLETYPE_CUSTOMER);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  //

  // public addSage(step: number, model: XeroCustomer){
  //     model.step = step;
  //     return this._http.post(`${API.CUSTOMER.ADD_SUPPLIER_CUSTOMER}`, model)
  //     .pipe(
  //         tap(() => {
  //             this._toastr.successCode(SUCCESS.ADD_SUPPLIER_CUSTOMER);
  //         }),
  //         catchError((err: ErrorResponse) => {
  //             this._toastr.errors(err.error.errors);
  //             throw err;
  //         })
  //     );
  // }

  // LAY TAT CA CAC CONTAC
  //public GetAllContact(checkStatus: Boolean) {
  //    // this._spinner.show()
  //    return this._http.post(`${API.CUSTOMER.GETALLCONTACT}`, { isCompany1: checkStatus })
  //        .pipe(tap(() => this._spinner.hide()));
  //}
  public GetAllContact(branchFlag: string) {
    // this._spinner.show()
    return this._http.post(`${API.CUSTOMER.GETALLCONTACT}`, { branchFlag: branchFlag })
      .pipe(tap(() => this._spinner.hide()));
  }
  // UPDATE CUSTOMER XERO CONTACT
  // public UpdateCustomerXeroContact(id: string, model: XeroCustomer){
  //     // this._spinner.show();
  //     return this._http.put(`${API.CUSTOMER.UPDATE_CUSTOMERXEROCONTACT(id)}`, model)
  //     .pipe(
  //         tap(() => {
  //             if(model.xeroContactID != null){
  //                 this._toastr.success(SUCCESS.UPDATE_CUSTOMER_XERO_CONTACT)
  //             }else{
  //                 this._toastr.success(SUCCESS.CREATE_CUSTOMER_XERO_CONTACT)
  //             }
  //             this._spinner.hide();
  //         }),
  //         catchError((err: ErrorResponse) => {
  //             this._toastr.errors(err.error.errors);
  //             throw err;
  //         })
  //     )
  // }

  // UPDATE SPEND
  public UpdateCustomerSpend(model) {
    return this._http.put(`${API.CUSTOMER.UPDATE_CUSTOMER_SPEND}`, model)
      .pipe(
        tap(() => {
          this._toastr.success(SUCCESS.UPDATE_CUSTOMER_SPEND_CONTACT)
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  // UPDATE CUSTOMER XERO CONTACT
  public CreateCustomerXeroContact(model: any) {
    // this._spinner.show();
    return this._http.post(`${API.CUSTOMER.CREATE_CUSTOMERXEROCONTACT}`, model)
      .pipe(
        tap(() => {
          if (model.xeroContactID != null) {
            this._toastr.success(SUCCESS.UPDATE_CUSTOMER_SPEND_CONTACT)
          } else {
            this._toastr.success(SUCCESS.CREATE_CUSTOMER_SPEND_CONTACT)
          }
          this._spinner.hide();
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  // UPDATE CUSTOMER XERO CONTEACT WITH CONTACTID
  public UpdateCustomerXeroContactWithContactID(idcutomer: string, idxero: string) {
    return this._http.put(`${API.CUSTOMER.UPDATE_CUSTOMER_XERO_CONTEACT_WITH_CONTACTID(idcutomer, idxero)}`, {})
      .pipe(
        tap(() => {
          this._spinner.hide();
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  // LAY THONG TIN CUA XERO TU ID CUSTOMER
  public GetCustomerXeroInfo(idcustomer: string) {
    return this._http.get(`${API.CUSTOMER.GET_CUSTOMER_XERO_INFO(idcustomer)}`).pipe(tap(() => this._spinner.hide()));
  }
  public getConsignmentOverview(request: ConsignmentOverviewRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<ConsignmentOverviewDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<ConsignmentOverviewDto>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_OVERVIEW}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public getConsignmentOverviewBySearchText(request: PaginationRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<ConsignmentOverviewDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<ConsignmentOverviewDto>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getConsignmentOverviewBySearchTextFromConId(request: PaginationRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<ConsignmentOverviewDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<ConsignmentOverviewDto>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT_FROMCONID}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getConsignmentOverviewBySearchTextFromCustNums(request: PaginationRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<ConsignmentOverviewDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<ConsignmentOverviewDto>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_OVERVIEW_BY_SEARCHTEXT_FROMCUSTNUMS}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }


  public getCustomerUsageSummary(): Observable<CustomerUsageSummaryDto> {
    this._spinner.show(true);
    return this._http.get<CustomerUsageSummaryDto>(`${API.CUSTOMER.GET_CUSTOMER_USAGE_SUMMARY}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public getCustomerStatus(request: CustomerStatusRequest, id: string, disableSpinner?: boolean)
    : Observable<Array<CustomerStatusDto>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<Array<CustomerStatusDto>>
      (`${API.CUSTOMER.GET_CUSTOMER_STATUS(id)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public exportData(request: ExportCustomerDataRequest, disableSpinner?: boolean) {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get(`${API.CUSTOMER.GET_EXPORT_DATA}?${requestQuery(request)}`, { responseType: 'blob' })
      .pipe(tap(() => this._spinner.hide()));
  }
  public getConsignmentByCustomerId(customerId: string, request: ConsignmentOverviewRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<Consignment>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Consignment>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_BY_CUSTOMER_ID(customerId)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }
  public getConsignmentByCustomerIdAndSearchText(customerId: string, request: ConsignmentOverviewRequest, disableSpinner?: boolean)
    : Observable<PaginationResponse<Consignment>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Consignment>>(
      `${API.CUSTOMER.GET_CONSIGNMENT_BY_CUSTOMER_ID_SEARCHTEXT(customerId)}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public print(id: string) {
    this._spinner.show();
    return this._http.get(`${API.CUSTOMER.PRINT(id)}`, {
      responseType: 'blob'
    }).pipe(tap(() => this._spinner.hide()));
  }

  public getCustomersForDropdown(disableSpinner?: boolean): Observable<Customer[]> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<Customer[]>(`${API.CUSTOMER.GET_CUSTOMER_FOR_DROPDOWN}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getCustomersForLookup(search: string): Observable<CustomerLookup[]> {

    return this._http.get<CustomerLookup[]>(`${API.CUSTOMER.GET_CUSTOMER_FOR_LOOKUP(search)}`);

  }

  public getCustomersForMinLookup(search: string): Observable<CustomerLookup[]> {

    return this._http.get<CustomerLookup[]>(`${API.CUSTOMER.GET_CUSTOMER_FOR_LOOKUP_MIN(search)}`);

  }

  public createQuotationCustomer(model): Observable<any> {
    this._spinner.show();
    return this._http.post(API.CUSTOMER.CREATE_QUOTATION_CUSTOMER, model).pipe(tap(() => this._spinner.hide()));
  }

  public getOperatingProcedure(customerId: string) {
    return this._http.get<StandardOperatingProcedure[]>(`${API.CUSTOMER.GET_CUSTOMER_SOP(customerId)}`)
  }
  public createOperatingProcedure(model: StandardOperatingProcedure) {
    return this._http.post<StandardOperatingProcedure>(API.CUSTOMER.OPERATING_PROCEDURE, model);
  }

  public bulkDeleteOperatingProcedure(model: BulkDelete) {
    return this._http.post(API.CUSTOMER.OPERATING_PROCEDURE_DELETE, model);
  }

  uploadCustomerAttachment(selectedFile, customerId): Promise<string> {
    const apiPath = API.CUSTOMER.UPLOAD_CUSTOMER_ATTACHMENT(customerId);
    const formData = new FormData();
    formData.append('attachment', selectedFile.file, selectedFile.fileName);
    return new Promise<string>((resolve, reject) => {
      this._http.patch<string>(apiPath, formData).subscribe(resolve, reject);
    });
  }

  getCustomerAttachment(mediaObjectId) {
    const apiPath = API.CUSTOMER.GET_CUSTOMER_ATTACHMENT(mediaObjectId);
    return this._http.get(apiPath, { responseType: 'blob' }).pipe(tap(() => this._spinner.hide()));

  }

  deleteCustomerAttachment(mediaObjectId) {
    const apiPath = API.CUSTOMER.DELETE_CUSTOMER_ATTACHMENT(mediaObjectId);
    return this._http.delete<boolean>(apiPath).pipe(tap(() => this._spinner.hide()));

  }
  getCustomerMediaObjects(customerId) {
    const apiPath = API.CUSTOMER.GET_CUSTOMER_MEDIAOBJECTS(customerId);
    return this._http.get<MediaObject[]>(apiPath).pipe(tap(() => this._spinner.hide()));

  }

  public getStOne(id: string): Observable<StandingOrderModel> {
    return this._http.get<StandingOrderModel>(`${API.STANDINGORDERS.GET_STANDINGORDER(id)}`).pipe();

  }

}

